import { BinaryQuestionTemplate } from '@templates';
import { useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { RoutesList } from '../../../routes/Routes';
import { ZodError } from 'zod';
import { ErrorMessages } from '@types';
import { contactUserOptionsSchema } from '../../validations/index';
import { parseZodErrors } from '@utils';
import { useBuskingStore } from '../../../../hooks';

const pageTitle = 'Do you want a confirmation email of your report?';
const description =
  "We can send an email to confirm that we've received your report.";

export const EmailConfirmationReport = () => {
  const { data, get, update } = useBuskingStore();
  const navigate = useNavigate();

  const [errorMessages, setErrorMessages] = useState<ErrorMessages[]>([]);

  const handleChange = (value: string) => {
    update('receiveConfirmationEmail', value);
    setErrorMessages([]);
  };

  const handleNext = () => {
    try {
      const receiveConfirmationEmail = get('receiveConfirmationEmail');
      contactUserOptionsSchema.parse({
        canWeContactYou: receiveConfirmationEmail,
      });
      navigate(RoutesList.CONTACT_USER_OPTION);
    } catch (error) {
      const validationErrors = parseZodErrors(error as ZodError);
      setErrorMessages(
        validationErrors.map((error: ErrorMessages) => ({
          ...error,
          href: error.path,
        })),
      );
    }
  };

  const buttonNext = {
    label: 'Next',
    onClick: handleNext,
  };

  const buttonPrevious = {
    onClick: () => navigate(RoutesList.ISSUE_LOCATION),
  };

  const options = [
    {
      labelText: 'Yes',
      isDefault: data?.receiveConfirmationEmail === 'Yes',
    },
    {
      labelText: 'No',
      isDefault: data?.receiveConfirmationEmail === 'No',
    },
  ];

  return (
    <>
      <BinaryQuestionTemplate
        description={<span className="font-normal">{description}</span>}
        title={pageTitle}
        options={options}
        onChange={handleChange}
        buttonNext={buttonNext}
        buttonPrevious={buttonPrevious}
        errorPath="canWeContactYou"
        errorMessages={errorMessages}
      ></BinaryQuestionTemplate>
    </>
  );
};
